<section class="servico-shell">
  <header class="servico-hero">
    <div>
      <h2 class="servico-title">{{ isEditMode ? 'Editar Serviço' : 'Novo Serviço' }}</h2>
      <p class="servico-subtitle">Preencha os dados do serviço.</p>
    </div>
    <span class="servico-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="servicoForm" (ngSubmit)="salvarServico()" id="servicoForm" class="servico-card">
    <div class="form-section">
      <h3>Dados do Serviço</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="nome" class="form-label">Nome</label>
          <input type="text" id="nome" formControlName="nome" class="form-control"
            [ngClass]="{ 'is-invalid': servicoForm.get('nome')?.invalid && servicoForm.get('nome')?.touched }">
          <div *ngIf="servicoForm.get('nome')?.invalid && servicoForm.get('nome')?.touched" class="invalid-feedback">
            Nome é obrigatório.
          </div>
        </div>
        <div class="col-md-6">
          <label for="precoVenda" class="form-label">Preço de Venda</label>
          <input type="number" id="precoVenda" formControlName="precoVenda" class="form-control"
            [ngClass]="{ 'is-invalid': servicoForm.get('precoVenda')?.invalid && servicoForm.get('precoVenda')?.touched }">
          <div *ngIf="servicoForm.get('precoVenda')?.invalid && servicoForm.get('precoVenda')?.touched" class="invalid-feedback">
            Preço de Venda é obrigatório.
          </div>
        </div>
        <div class="col-md-12">
          <label for="descricao" class="form-label">Descrição</label>
          <textarea id="descricao" formControlName="descricao" class="form-control" rows="3"></textarea>
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
    <button type="submit" form="servicoForm" class="btn btn-primary" [disabled]="servicoForm.invalid">Salvar</button>
  </footer>
</section>
